var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8M8 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m4.92-3.691A7.97 7.97 0 0 1 10 18a7.97 7.97 0 0 1-4.92-1.691A3 3 0 0 1 8 14h4c1.419 0 2.608.985 2.92 2.309m1.535-1.582A5 5 0 0 0 12 12H8a5 5 0 0 0-4.455 2.727 8 8 0 1 1 12.91 0",
    clipRule: "evenodd"
  })));
};
export default SvgUser;